/**
 * HICC buy box ETA — stock (beside qty) + delivery reveal (above buy buttons).
 */
(function () {
  const STOCK_PATH_IN = 'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM374 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L221.1 315.2 169 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8L379.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z';
  const STOCK_PATH_OUT =
    'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-192a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-192c-18.2 0-32.7 15.5-31.4 33.7l7.4 104c.9 12.6 11.4 22.3 23.9 22.3 12.6 0 23-9.7 23.9-22.3l7.4-104c1.3-18.2-13.1-33.7-31.4-33.7z';

  function afterNextPaint(cb) {
    requestAnimationFrame(() => requestAnimationFrame(cb));
  }

  function styleArrivesByDelivery(content) {
    const dt = content.querySelector('.arrivesby-dt');
    if (!dt || dt.dataset.pdpEtaStyled === '1') return;
    dt.dataset.pdpEtaStyled = '1';
    dt.querySelector('.inline-icon')?.setAttribute('hidden', '');
    dt.querySelectorAll('div, p, span').forEach((el) => {
      if (el.closest('.date-text') || el.querySelector('.date-range')) return;
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/free\s*shipping/i.test(text) && !el.querySelector('.date-range')) {
        el.setAttribute('data-pdp-eta-offer-hidden', '');
      }
    });
    dt.querySelectorAll('.date-text *').forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) return;
      const next = node.textContent.replace(/\bArrives\s+by\b/gi, 'Arrives');
      if (next !== node.textContent) node.textContent = next;
    });
    patchArrivesByFormA11y(content.closest('.pdp-hicc-delivery-app, .pdp-hicc-buybox-eta, [data-pdp-delivery-proxy]') || content);
  }

  function hasAccessibleName(el) {
    if ((el.textContent || '').replace(/\s+/g, ' ').trim()) return true;
    if ((el.getAttribute('aria-label') || '').trim()) return true;
    if ((el.getAttribute('title') || '').trim()) return true;
    const labelledby = el.getAttribute('aria-labelledby');
    if (labelledby && document.getElementById(labelledby)) return true;
    return false;
  }

  function patchArrivesByFormA11y(scope) {
    const root = scope?.querySelectorAll ? scope : document;
    root.querySelectorAll('[id^="zipcode-popover-"]').forEach((popover) => {
      const input = popover.querySelector('input:not([type="hidden"])');
      const headerText = (popover.querySelector('header h1, header h2, header h3, header h4, header h5, header h6')?.textContent || popover.querySelector('header')?.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();
      const labelText = headerText || 'ZIP code';

      if (input) {
        if (!input.id) input.id = popover.id + '-input';

        if (!popover.querySelector(`label[for="${input.id}"]`)) {
          const label = document.createElement('label');
          label.className = 'sr-only';
          label.setAttribute('for', input.id);
          label.textContent = labelText;
          input.parentNode.insertBefore(label, input);
        }

        // One accessible name only — label + aria-label triggers "Multiple form labels"
        input.removeAttribute('aria-label');
        input.dataset.hiccA11yPatched = '1';
      }

      popover.querySelectorAll('button').forEach((btn) => {
        if (btn.dataset.hiccA11yPatched === '1') return;
        if (!hasAccessibleName(btn)) {
          btn.setAttribute('aria-label', 'Close');
        }
        btn.dataset.hiccA11yPatched = '1';
      });
    });
  }

  const deliverySessions = new WeakMap();

  function getDeliverySession(wrap) {
    if (!deliverySessions.has(wrap)) {
      deliverySessions.set(wrap, {
        token: 0,
        pollTimers: [],
        observer: null,
        finalTimer: null,
        abortController: null,
      });
    }
    return deliverySessions.get(wrap);
  }

  function cancelDeliveryWatch(wrap) {
    if (!wrap) return;
    const session = getDeliverySession(wrap);
    session.pollTimers.forEach((id) => clearTimeout(id));
    session.pollTimers = [];
    if (session.finalTimer) {
      clearTimeout(session.finalTimer);
      session.finalTimer = null;
    }
    if (session.observer) {
      session.observer.disconnect();
      session.observer = null;
    }
    if (session.abortController) {
      session.abortController.abort();
      session.abortController = null;
    }
  }

  function bumpDeliveryRequest(wrap) {
    cancelDeliveryWatch(wrap);
    const session = getDeliverySession(wrap);
    session.token += 1;
    return session.token;
  }

  function isDeliveryRequestActive(wrap, requestToken) {
    return getDeliverySession(wrap).token === requestToken;
  }

  function beginDeliveryLoading(wrap) {
    if (!wrap) return;
    const skeleton = wrap.querySelector('[data-pdp-eta-delivery-skeleton]');
    const content = wrap.querySelector('[data-pdp-eta-delivery-content]');
    wrap.dataset.pdpEtaDeliveryLoading = 'true';
    wrap.setAttribute('aria-busy', 'true');
    if (skeleton) skeleton.classList.remove('hidden');
    if (content) {
      content.classList.add('hidden');
      content.classList.remove('invisible');
    }
  }

  function endDeliveryLoading(wrap) {
    if (!wrap) return;
    wrap.dataset.pdpEtaDeliveryLoading = 'false';
    wrap.removeAttribute('aria-busy');
    wrap.querySelector('[data-pdp-eta-delivery-skeleton]')?.classList.add('hidden');
    const content = wrap.querySelector('[data-pdp-eta-delivery-content]');
    if (content) content.classList.remove('hidden', 'invisible');
  }

  function deliveryContentReady(content) {
    if (!content) return false;
    const text = (content.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length < 8) return false;
    const range = content.querySelector('.date-range, .date-text');
    if (range && (range.textContent || '').replace(/\s+/g, ' ').trim().length >= 3) {
      return true;
    }
    if (
      /arrives/i.test(text) &&
      /\d|Mon|Tue|Wed|Thu|Fri|Sat|Sun|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec/i.test(text)
    ) {
      return true;
    }
    return false;
  }

  function revealDeliveryWrap(wrap) {
    if (!wrap) return;
    const skeleton = wrap.querySelector('[data-pdp-eta-delivery-skeleton]');
    const content = wrap.querySelector('[data-pdp-eta-delivery-content]');
    if (!content || !deliveryContentReady(content)) return;
    styleArrivesByDelivery(content);
    content.classList.remove('hidden', 'invisible');
    afterNextPaint(() => {
      wrap.dataset.pdpEtaDeliveryLoading = 'false';
      wrap.removeAttribute('aria-busy');
      if (skeleton) skeleton.classList.add('hidden');
    });
  }

  function bindDeliveryWatch(wrap, requestToken) {
    if (!wrap) return;
    const content = wrap.querySelector('[data-pdp-eta-delivery-content]');
    if (!content) return;

    cancelDeliveryWatch(wrap);
    const session = getDeliverySession(wrap);
    if (requestToken == null) {
      session.token += 1;
      requestToken = session.token;
    }
    const watchToken = requestToken;
    const tryReveal = () => {
      if (!isDeliveryRequestActive(wrap, watchToken)) return;
      revealDeliveryWrap(wrap);
    };
    const isFetch = wrap.dataset.pdpEtaDeliveryFetch === '1';
    const pollSchedule = isFetch
      ? [200, 400, 600, 900, 1200, 1600, 2200, 3000, 4000, 5000, 6500, 8000, 10000]
      : [300, 600, 1200, 2000, 3500, 5000, 8000];

    wrap.dataset.pdpEtaDeliveryBound = '1';
    if (!deliveryContentReady(content)) {
      beginDeliveryLoading(wrap);
    }
    tryReveal();

    const obs = new MutationObserver(() => {
      tryReveal();
      patchArrivesByFormA11y(wrap);
    });
    session.observer = obs;
    obs.observe(content, { childList: true, subtree: true, characterData: true });
    pollSchedule.forEach((ms) => {
      const id = setTimeout(() => tryReveal(), ms);
      session.pollTimers.push(id);
    });

    session.finalTimer = setTimeout(() => {
      if (!isDeliveryRequestActive(wrap, watchToken)) return;
      if (wrap.dataset.pdpEtaDeliveryLoading !== 'true') return;
      if (deliveryContentReady(content)) {
        tryReveal();
        return;
      }
      if (!isFetch) tryReveal();
      else endDeliveryLoading(wrap);
    }, isFetch ? 12000 : 8000);
  }

  const hiccSectionIdCache = new Map();

  function getProxySectionId() {
    return window.PdpHiccDeliveryProxySectionId || 'pdp_hicc_delivery_proxy';
  }

  function parseHtml(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function parseFragment(html) {
    return new DOMParser().parseFromString(
      '<div id="pdp-eta-fragment-root">' + html + '</div>',
      'text/html'
    );
  }

  function extractDeliveryHtml(doc) {
    const selectors = [
      '[data-pdp-delivery-proxy]',
      '.pdp-hicc-delivery-proxy',
      '.main-product-hicc .pdp-hicc-buybox-eta [data-pdp-eta-delivery-content]',
      '.pdp-hicc-buybox-eta [data-pdp-eta-delivery-content]',
    ];
    for (const sel of selectors) {
      const node = doc.querySelector(sel);
      const html = node?.innerHTML?.trim();
      if (html && html.length > 10) return html;
    }
    const widget = doc.querySelector('.pdp-hicc-delivery-app .arrivesby-dt, .arrivesby-dt');
    return widget ? widget.outerHTML : '';
  }

  function ensureArrivesbyScriptsFromHtml(html) {
    const doc = typeof html === 'string' ? parseHtml(html) : html;
    doc.querySelectorAll('script[src]').forEach((old) => {
      const src = old.getAttribute('src') || '';
      if (!/arrivesby|arrives-by/i.test(src)) return;
      if ([...document.scripts].some((s) => s.src === src)) return;
      const s = document.createElement('script');
      s.src = src;
      s.async = true;
      if (old.defer) s.defer = true;
      document.head.appendChild(s);
    });
  }

  function runScriptsInContainer(container) {
    if (!container) return;
    container.querySelectorAll('script').forEach((old) => {
      const s = document.createElement('script');
      [...old.attributes].forEach((attr) => s.setAttribute(attr.name, attr.value));
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  function findHiccSectionId(doc) {
    const node =
      doc.querySelector('[id^="shopify-section-main_product_hicc"]') ||
      doc.querySelector('.main-product-hicc[id^="shopify-section-"]');
    if (node?.id?.startsWith('shopify-section-')) {
      return node.id.replace('shopify-section-', '');
    }
    const match = doc.documentElement.innerHTML.match(
      /shopify-section-(main_product_hicc_[A-Za-z0-9]+)/
    );
    return match ? match[1] : null;
  }

  async function fetchSectionsHtml(productUrl, sectionIds, variantId, signal) {
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('sections', sectionIds.filter(Boolean).join(','));
    if (variantId) url.searchParams.set('variant', variantId);
    const res = await fetch(url.toString(), { signal });
    if (!res.ok) return null;
    try {
      return await res.json();
    } catch (err) {
      if (err && err.name === 'AbortError') throw err;
      return null;
    }
  }

  function extractFromSectionsJson(sectionsJson, sectionIds) {
    if (!sectionsJson) return '';
    for (const id of sectionIds) {
      if (!id || !sectionsJson[id]) continue;
      const doc = parseFragment(sectionsJson[id]);
      const html = extractDeliveryHtml(doc);
      if (html) return html;
    }
    return '';
  }

  async function resolveHiccSectionId(productUrl, signal) {
    const handle = (productUrl.match(/\/products\/([^/?#]+)/) || [])[1];
    if (handle && hiccSectionIdCache.has(handle)) {
      return hiccSectionIdCache.get(handle);
    }
    const url = new URL(productUrl, window.location.origin);
    const res = await fetch(url.toString(), { signal });
    if (!res.ok) return null;
    const html = await res.text();
    ensureArrivesbyScriptsFromHtml(html);
    const id = findHiccSectionId(parseHtml(html));
    if (handle && id) hiccSectionIdCache.set(handle, id);
    return id;
  }

  async function loadDeliveryHtml(productUrl, variantId, signal) {
    const proxyId = getProxySectionId();
    const sectionIds = [proxyId];
    let sectionsJson = await fetchSectionsHtml(productUrl, sectionIds, variantId, signal);
    let inner = extractFromSectionsJson(sectionsJson, sectionIds);

    const hiccId = await resolveHiccSectionId(productUrl, signal);
    if (hiccId && !inner) {
      sectionIds.push(hiccId);
      sectionsJson = await fetchSectionsHtml(productUrl, [proxyId, hiccId], variantId, signal);
      inner = extractFromSectionsJson(sectionsJson, sectionIds);
    }

    if (inner) return inner;

    const url = new URL(productUrl, window.location.origin);
    if (variantId) url.searchParams.set('variant', variantId);
    const res = await fetch(url.toString(), { signal });
    if (!res.ok) return '';
    const html = await res.text();
    ensureArrivesbyScriptsFromHtml(html);
    return extractDeliveryHtml(parseHtml(html));
  }

  async function fetchDeliveryFromPdp(wrap, productUrl, variantId) {
    const content = wrap?.querySelector('[data-pdp-eta-delivery-content]');
    if (!wrap || !content || !productUrl) return;

    const cacheKey = productUrl + '|' + (variantId || '');
    const requestToken = bumpDeliveryRequest(wrap);
    const session = getDeliverySession(wrap);
    session.abortController = new AbortController();
    const { signal } = session.abortController;

    if (wrap.dataset.pdpEtaDeliveryCacheKey === cacheKey && content.innerHTML.trim()) {
      if (!isDeliveryRequestActive(wrap, requestToken)) return;
      bindDeliveryWatch(wrap, requestToken);
      return;
    }

    beginDeliveryLoading(wrap);
    wrap.dataset.pdpEtaDeliveryBound = '0';

    try {
      const inner = await loadDeliveryHtml(productUrl, variantId, signal);
      if (!isDeliveryRequestActive(wrap, requestToken)) return;
      if (!inner) {
        endDeliveryLoading(wrap);
        return;
      }
      content.innerHTML = inner;
      runScriptsInContainer(content);
      patchArrivesByFormA11y(wrap);
      wrap.dataset.pdpEtaDeliveryCacheKey = cacheKey;
      if (!isDeliveryRequestActive(wrap, requestToken)) return;
      bindDeliveryWatch(wrap, requestToken);
      document.dispatchEvent(new CustomEvent('shopify:section:load'));
    } catch (err) {
      if (err && err.name === 'AbortError') return;
      if (!isDeliveryRequestActive(wrap, requestToken)) return;
      endDeliveryLoading(wrap);
    }
  }

  function parseSelectedVariantFromHtml(html) {
    if (!html || typeof html.querySelector !== 'function') return null;
    const script = html.querySelector('script[type="application/json"][data-selected-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (err) {
      return null;
    }
  }

  class PdpHiccBuyboxEta {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.stockEl = root.querySelector('[data-pdp-eta-stock]');
      this.stockIcon = root.querySelector('[data-pdp-eta-stock-icon]');
      this.stockPath = root.querySelector('[data-pdp-eta-stock-path]');
      this.stockLabel = root.querySelector('[data-pdp-eta-stock-label]');
      this.shipsWithinEl = root.querySelector('[data-pdp-eta-ships-within]');
      this.shippingOnetimeEl = root.querySelector('[data-pdp-eta-shipping-onetime]');
      this.shippingSubscribeEl = root.querySelector('[data-pdp-eta-shipping-subscribe]');
      this.deliveryWrap = root.querySelector('[data-pdp-eta-delivery-app]');
      this._variantMap = null;
      this._deliveryFetchTimer = null;

      if (this.deliveryWrap?.dataset.pdpEtaDeliveryFetch === '1') {
        this.bindPdpDeliveryFetch();
      } else {
        bindDeliveryWatch(this.deliveryWrap);
      }

      this.bindVariantEvents();
      this.bindPurchaseModeEvents();
      this.updateShippingNote({
        hasSubscription: root.dataset.hasSubscription === 'true',
        mode: this.getPurchaseMode(),
      });
    }

    getPurchaseMode() {
      const subRoot = document.getElementById('pdp-subscription-hicc-' + this.sectionId);
      if (!subRoot || subRoot.dataset.supported !== 'true') return 'onetime';
      const widget = subRoot.__pdpSubscriptionHicc;
      if (widget && widget.mode) return widget.mode;
      const checked = subRoot.querySelector('[data-pdp-purchase-radio]:checked');
      if (checked) return checked.value === 'subscribe' ? 'subscribe' : 'onetime';
      return subRoot.dataset.pdpMode === 'subscribe' ? 'subscribe' : 'onetime';
    }

    updateShippingNote({ hasSubscription, mode }) {
      const showOnetime = !hasSubscription || mode === 'onetime';
      const showSubscribe = hasSubscription && mode === 'subscribe';
      if (this.shippingOnetimeEl) {
        this.shippingOnetimeEl.classList.toggle('hidden', !showOnetime);
      }
      if (this.shippingSubscribeEl) {
        this.shippingSubscribeEl.classList.toggle('hidden', !showSubscribe);
      }
    }

    bindPdpDeliveryFetch() {
      const productUrl = this.root.dataset.productUrl;
      if (!productUrl || !this.deliveryWrap) return;
      this.scheduleDeliveryFetch(productUrl);
    }

    scheduleDeliveryFetch(productUrl) {
      if (!productUrl || !this.deliveryWrap) return;
      clearTimeout(this._deliveryFetchTimer);
      this._deliveryFetchTimer = setTimeout(() => {
        this._deliveryFetchTimer = null;
        if (!document.body.contains(this.root)) return;
        const variantId = document.getElementById('update-variant-' + this.sectionId)?.value;
        fetchDeliveryFromPdp(this.deliveryWrap, productUrl, variantId);
      }, 280);
    }

    bindPurchaseModeEvents() {
      document.addEventListener('pdp-hicc:purchase-mode', (e) => {
        if (!e.detail || String(e.detail.sectionId) !== String(this.sectionId)) return;
        this.updateShippingNote({
          hasSubscription: this.root.dataset.hasSubscription === 'true',
          mode: e.detail.mode === 'subscribe' ? 'subscribe' : 'onetime',
        });
      });
    }

    getVariantMap() {
      if (this._variantMap) return this._variantMap;
      const el = document.getElementById('pdp-hicc-variants-' + this.sectionId);
      if (!el) return {};
      try {
        const list = JSON.parse(el.textContent);
        this._variantMap = {};
        (list || []).forEach((v) => {
          this._variantMap[String(v.id)] = v;
        });
      } catch (err) {
        this._variantMap = {};
      }
      return this._variantMap;
    }

    resolveVariantMeta(variantId) {
      return this.getVariantMap()[String(variantId)] || null;
    }

    bindVariantEvents() {
      const eventName = 'eurus:product-page-variant-select:updated:' + this.sectionId;
      document.addEventListener(eventName, (e) => {
        const selected = parseSelectedVariantFromHtml(e.detail?.html);
        const variantId =
          selected?.id ||
          document.getElementById('update-variant-' + this.sectionId)?.value;
        if (!variantId) return;
        this.syncFromVariantId(variantId, selected);
      });
    }

    updateStockState(inStock) {
      if (!this.stockEl) return;
      this.root.dataset.stockInStock = inStock ? 'true' : 'false';
      this.stockEl.dataset.stockState = inStock ? 'in-stock' : 'sold-out';
      this.stockEl.classList.remove('hidden');
      this.stockEl.classList.toggle('text-[#148A44]', inStock);
      this.stockEl.classList.toggle('text-red-600', !inStock);
      if (this.stockPath) {
        this.stockPath.setAttribute('d', inStock ? STOCK_PATH_IN : STOCK_PATH_OUT);
      }
      if (this.stockLabel) {
        this.stockLabel.textContent = inStock ? 'In Stock' : 'Sold out';
      }
      if (this.shipsWithinEl) {
        this.shipsWithinEl.classList.toggle('hidden', !inStock);
      }
    }

    syncFromVariantId(variantId, selectedFromHtml) {
      const meta = this.resolveVariantMeta(variantId);
      const inStock = meta ? meta.in_stock === true : Boolean(selectedFromHtml?.available);
      this.updateStockState(inStock);

      const hasSub = meta
        ? meta.has_subscription === true
        : (selectedFromHtml?.selling_plan_allocations || []).length > 0;
      this.root.dataset.hasSubscription = hasSub ? 'true' : 'false';
      this.updateShippingNote({
        hasSubscription: hasSub,
        mode: this.getPurchaseMode(),
      });
      if (this.deliveryWrap?.dataset.pdpEtaDeliveryFetch === '1') {
        const productUrl = this.root.dataset.productUrl;
        if (productUrl) this.scheduleDeliveryFetch(productUrl);
      } else {
        cancelDeliveryWatch(this.deliveryWrap);
        bindDeliveryWatch(this.deliveryWrap);
      }
    }
  }

  function init() {
    document.querySelectorAll('.pdp-hicc-buybox-eta').forEach((root) => {
      if (root.__pdpHiccBuyboxEta) return;
      root.__pdpHiccBuyboxEta = new PdpHiccBuyboxEta(root);
    });
    patchArrivesByFormA11y(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('quickview:content:loaded', init);
  window.PdpHiccBuyboxEtaInit = init;
})();
